// URLs
export const CLIENT_URL = window.location.origin;
export const SERVER_URL = "";

// KEYS TO CODE MAP
export const keyToCodeMap = {
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
};
